/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Drift_Step_2Inputs */

const en_landing_drift_step_2 = /** @type {(inputs: Landing_Drift_Step_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Edit 2 · cup → orange juice`)
};

const zh_landing_drift_step_2 = /** @type {(inputs: Landing_Drift_Step_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`编辑 2 · 咖啡杯 → 橙汁`)
};

/**
* | output |
* | --- |
* | "Edit 2 · cup → orange juice" |
*
* @param {Landing_Drift_Step_2Inputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const landing_drift_step_2 = /** @type {((inputs?: Landing_Drift_Step_2Inputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Drift_Step_2Inputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_landing_drift_step_2(inputs)
	return zh_landing_drift_step_2(inputs)
});
export { landing_drift_step_2 as "landing.drift.step_2" }